
import React, { useState,useContext } from 'react'
import { IconCheck } from '../../svg/index'
import Modal from "react-modal";
import SOA from '../../SOA';
import { DataContext } from '../../data/DataContext';


const Step1 = () => {
  const { SOA, setSOA, changeHandler } = useContext(DataContext);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);


  return (
    <div className="step">
      <div className="step-container-soa">
        <div className="mt-15 mb-30">
          <span className="title2">
          Antes de iniciar, tené a mano los siguientes documentos:
                </span>
        </div>
        <div>
          <div className="group-p mt-10 pl-30" >
            <IconCheck />
            <span className="txt1">Circulación de tu vehículo</span>
          </div>
          <div className="group-p mt-10 pl-30" >
            <IconCheck />
            <span className="txt1">Documento de identificación</span>
          </div>
          <div className="group-p mt-10 pl-30" >
            <IconCheck />
            <span className="txt1">Tarjeta de débito o crédito</span>
          </div>
        </div>
        <div className="mt-50 mb-50 pl-30">
          <input type="checkbox" name="acceptaTermino" checked={SOA.acceptaTermino}  onChange={e => setSOA({ ...SOA, acceptaTermino: e.target.checked })}  className="" name="acceptaTerminos" id="acceptaTerminos" required />
          <a rel='noreferrer'  onClick={handleShow} target='_blank' className="terminoscondiciones">Acepto términos y condiciones de uso</a>
        </div>
      </div>
      <Modal className="modal" isOpen={show} show={show}  ariaHideApp={false} autoFocus={false} onHide={handleClose} autoFocus={false}>
        <div className="modal-title">
          <span className="txt-title-modal">Términos y condiciones para solicitar en línea</span>
        </div>
        <div className="modal-body-info">
          <span className="title4"><strong>CARNET DE SEGURO</strong> </span>
          <p className="title4">* Una vez que usted compre su Seguro Obligatorio de Automóvil en Línea queda automáticamente cubierto ante cualquier eventualidad, sin embargo, Seguros LAFISE no se hace responsable en caso de multa de tránsito por no portar su carnet de seguro.</p>

          <p className="title4">* El carnet puede ser retirado en la sucursal de su preferencia o bien, podemos enviarlo a tu domicilio si resides en la ciudad de Managua.</p>

          <p className="title4">* El retiro o envío de su carnet podrá hacerse efectivo en un tiempo máximo de 24 horas hábiles.</p>

        </div>
        <div className="modal-footer">
          <button type="button" tabindex="-1" className="modal-btn-close" onClick={handleClose}>Cerrar</button>
        </div>
      </Modal>
    </div>
  );
}

export default Step1;